if ($('.type-post').length) {
    var articleImg = $('.news-item-detail meta[itemprop="url"]').attr('content');
    $('.news-item-detail').prepend('<div class="fullImage"><img src="' + articleImg + '" alt="Obaly"></div>');



}

